import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { IMG } from "../content/images";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowRight } from "lucide-react";

const Rural = () => {
  const { t, p } = useLang();
  return (
    <div data-testid="rural-page">
      <Seo title={t.nav.rural} path="connectivite-rurale" />
      <PageHero eyebrow="BULA TELECOMS SA — IMPACT" title={t.ruralPage.heading}
        image={IMG.ruralCommunity} crumbs={[{ label: t.nav.rural }]} />

      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="text-base sm:text-lg text-[#101214]/75 leading-relaxed">{t.ruralPage.p1}</p>
            <p className="mt-5 text-base sm:text-lg text-[#101214]/75 leading-relaxed">{t.ruralPage.p2}</p>
            <Link to={p("demander-un-devis")} data-testid="rural-project-cta"
              className="mt-8 inline-flex items-center gap-2 bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] font-black rounded-full px-7 py-3.5 text-sm transition-colors">
              {t.ruralPage.cta} <ArrowRight size={16} />
            </Link>
          </Reveal>
          <Reveal delay={120}>
            <img src={IMG.ruralSchool} alt="" loading="lazy" className="rounded-2xl border border-[#101214]/10 shadow-xl w-full object-cover aspect-[4/3]" />
          </Reveal>
        </div>
      </section>

      <section className="bg-[#101214]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24">
          <Reveal><h2 className="text-2xl sm:text-3xl font-black tracking-tight text-white">{t.ruralPage.impactTitle}</h2></Reveal>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5">
            {t.ruralPage.impacts.map((impact, i) => (
              <Reveal key={impact} delay={i * 60}>
                <div className="border border-white/10 hover:border-[#FF6600]/50 rounded-2xl p-6 text-center transition-colors">
                  <span className="block w-2.5 h-2.5 rounded-full bg-[#FF6600] mx-auto mb-3 shadow-[0_0_10px_rgba(255,102,0,0.7)]" />
                  <p className="text-white font-bold text-sm">{impact}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default Rural;
